module.exports = __webpack_public_path__ + "img/123.c75fe40c.png";